module.exports = __webpack_public_path__ + "img/andreea-thank-you-cta.af30d53b.png";